import { ReactComponent as CLIENTS } from "./assets/icons/options/clients.svg";
import { ReactComponent as CUSTOMIZATION } from "./assets/icons/options/customization.svg";
import { ReactComponent as FINANCE } from "./assets/icons/options/finance.svg";
import { ReactComponent as GENERAL } from "./assets/icons/options/general.svg";
import { ReactComponent as PROJECTS } from "./assets/icons/options/projects.svg";
import { ReactComponent as SECURITY } from "./assets/icons/options/security.svg";

export const MainNavigation = [
	{ text: "Dashboard", slug: "/dashboard" },
	{
		text: "Quotes",
		slug: "/quotes",
		sub: [
			{
				text: "Index",
				slug: "/quotes",
				ico: GENERAL,
			},
			{
				text: "Create",
				slug: "/quotes/create",
				ico: GENERAL,
			},
		],
	},
	{ text: "Projects", slug: "/projects" },
	{
		text: "Invoices",
		slug: "/invoices",
		sub: [
			{ text: "Index",          slug: "/invoices",        ico: GENERAL },
			{ text: "Create invoice", slug: "/invoices/create", ico: GENERAL },
		],
	},
	{
		text: "Contacts",
		slug: "/clients",
		sub: [
			{ text: "Clients", slug: "/clients", ico: CLIENTS },
			{ text: "Resources", slug: "/resources", ico: GENERAL },
		],
	},
	{ text: "Analytics", slug: "/analytics/projects" },
	{
		text: "Settings",
		slug: "/options/finance/clients-price-list?tab=clients-price-list",
		sub: [
			{
				text: "General settings",
				slug: "/options/finance/clients-price-list?tab=clients-price-list",
				ico: GENERAL,
			},
			{ text: "Finance", slug: "/options/finance/clients-price-list?tab=clients-price-list" },
			{ text: "Projects", slug: "#" },
			{ text: "Clients and vendors", slug: "/clients" },
			{ text: "Security", slug: "/options/security/users-roles?tab=users-roles" },
			{
				text: "Customization",
				slug: "/options/customization/pdf-templates?tab=pdf-templates",
				ico: CUSTOMIZATION,
			},
		],
	},
];

export const OptionsSidebar = [
	{ text: "General settings", slug: "/options/general/profile", ico: GENERAL },
	{ text: "Finance", slug: "/options/finance/clients-price-list?tab=clients-price-list", ico: FINANCE },
	{ text: "Projects", slug: "#", ico: PROJECTS },
	{ text: "Clients and vendors", slug: "/clients", ico: CLIENTS },
	{ text: "Security", slug: "/options/security/users-roles?tab=users-roles", ico: SECURITY },
	{
		text: "Customization",
		slug: "/options/customization/pdf-templates?tab=pdf-templates",
		ico: CUSTOMIZATION,
	},
];